import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class ReportsArchiveRoute extends Route {
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;
	@service('model-manager/report-deliveries')
	declare mmReportDeliveriesService: Service.ModelManager.ReportDeliveries;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		const promises: Promise<unknown>[] = [];
		promises.push(this.navigationService.initialRequestsPromise);
		promises.push(this.mmReportsService.requestReports());
		promises.push(this.mmReportDeliveriesService.requestReportDeliveries());

		return Promise.all(promises);
	}
}
